import { render, staticRenderFns } from "./ultimTab.vue?vue&type=template&id=061409d2&scoped=true&"
import script from "./ultimTab.vue?vue&type=script&lang=js&"
export * from "./ultimTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061409d2",
  null
  
)

export default component.exports